{
  "email-phone-confirmation-pin-dialog": {
    "buttons": {
      "resend": "Resend",
      "submit": "Submit"
    },
    "text": {
      "email-confirmation": "Email confirmation",
      "enter-to-confirm-email": "Please enter PIN code to confirm your email",
      "enter-to-confirm-phone": "Please enter PIN code to confirm your phone number",
      "in-second": "in {{seconds}} s",
      "phone-confirmation": "Phone number confirmation",
      "pin-sent-to-email": "The PIN code is sent to your email",
      "pin-sent-to-phone": "The PIN code is sent to your phone number",
      "update-success": "Updated successfully!"
    }
  }
}
